import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Login, MyAccount } from './MobileMenuTopItems';
import { forMobileOnly } from '../Common/Helper';
import { NavImgButton } from './ViewComponents';
import config from '../../config';

const menuItemsBlockType = {
  text: 'text',
  image: 'image',
  dynamic_image: 'dynamic_image',
};

const PassButton = forMobileOnly(NavImgButton);
const PbLiveButton = forMobileOnly(NavImgButton);

export default class SideBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      otherCheckboxStatus: false,
    };
  }

  renderDynamicImageItem(value) {
    const title = [
      <li className="mmm__item mmm__item--sub mmm__item--sub-title">
        {value.headerLabel}
      </li>,
    ];
    const subitem = {
      label: value.footerLabel,
      href: value.headerHref,
    };
    const items = [this.renderItems(subitem)];

    return [...title, ...items];
  }

  renderNonDynamicImageItem(value) {
    const title = [
      <li className="mmm__item mmm__item--sub mmm__item--sub-title">
        {value.headerLabel}
      </li>,
    ];

    let items;
    if (value.type === menuItemsBlockType.text) {
      items = value.menuSubitems.map((v) => this.renderItems(v));
    } else if (value.type === menuItemsBlockType.image) {
      const subitem = {
        label: value.footerLabel,
        href: value.headerHref,
      };
      items = [this.renderItems(subitem)];
    }

    return [...title, ...items];
  }

  renderListItems(value) {
    if (value.type === menuItemsBlockType.dynamic_image) {
      return this.renderDynamicImageItem(value);
    }

    return this.renderNonDynamicImageItem(value);
  }

  renderItems(value) {
    return (
      <li className="mmm__item mmm__item--sub">
        <a
          href={this.props.tRoute(value.href)}
          onClick={this.props.toggleSidebar}
        >
          {value.label}
        </a>
      </li>
    );
  }

  moveLastItemToTop(arr) {
    if (arr[0] !== undefined) {
      arr.splice(0, 0, arr.splice(-1, 1)[0]);
    }

    return arr;
  }

  componentWillUpdate(nextProps) {
    if (!nextProps.sideBarOpen && this.props.sideBarOpen) {
      this.setState({
        otherCheckboxStatus: false,
      });
    }
  }

  render() {
    const {
      store: { has_active_subscriptions = false },
      userHeaderInfo: { isSubscriber = false },
      shouldPushHeaderDown,
      headerTopPx,
    } = this.props;
    const pushDownStyle = shouldPushHeaderDown
      ? { marginTop: headerTopPx + 'px' }
      : {};
    const menus = this.moveLastItemToTop([...this.props.menus]);
    const passLink = isSubscriber ? '/account/dashboard/pass' : '/pass';

    return (
      <ul className="mmm">
        <li className="mmm__item-outside mmm__item-outside--container">
          <input
            id="mobile-menu-toggle"
            type="checkbox"
            className="mmm__toggle"
            checked={this.props.sideBarOpen}
            onChange={this.props.toggleSidebar}
          />
          <label htmlFor="mobile-menu-toggle" className="mmm__button">
            <i className="fa fa-bars"></i>
          </label>
          <ul className="mmm__menu mmm__menu--main" style={pushDownStyle}>
            <li
              className="mmm__item mmm__item--close-link"
              onClick={this.props.toggleSidebar}
            >
              <i className="fa fa-close"></i>
              <img
                className="mmm__logo"
                src={this.props.logo}
                alt={this.props.store.name}
              />
            </li>
            <span onClick={this.props.toggleSidebar}>
              <Login />
            </span>
            <MyAccount onClick={this.props.toggleSidebar} {...this.props} />
            {has_active_subscriptions && (
              <li className="mmm__item">
                <Link to={passLink} onClick={this.props.toggleSidebar}>
                  <PassButton
                    src={`${config.s3BucketUrl}/subscriptions/pass-logo.png`}
                    style={{
                      height: '1.5rem',
                      marginLeft: '-.7rem',
                    }}
                  />
                </Link>
              </li>
            )}
            <li className="mmm__item">
              <Link
                to={`${config.trackerUrl}/track?redirect=${encodeURIComponent(
                  config.pbLiveUrl
                )}`}
                target="_blank"
              >
                <PbLiveButton
                  src={`${config.s3BucketUrl}/logos/pb-live-logo.51e37b9e69b32f14e6f92042717fb961.svg`}
                  style={{
                    height: '1.95rem',
                    marginLeft: '-.55rem',
                  }}
                />
              </Link>
            </li>
            {menus.map((menu, i) => {
              if (menu.href === '/promotions') {
                return (
                  <li key={i} className="mmm__item mmm__item--highlight">
                    <Link
                      to={this.props.tRoute(menu.href)}
                      onClick={this.props.toggleSidebar}
                    >
                      {menu.label}
                    </Link>
                  </li>
                );
              }
              if (menu.menuItems.length) {
                return (
                  this.props.sideBarOpen && (
                    <li key={i} className="mmm__item">
                      <input
                        type="checkbox"
                        id={`sub-${i}`}
                        className="mmm__submenu-toggle"
                      />
                      <label className="mmm__label" htmlFor={`sub-${i}`}>
                        <span>{menu.label}</span>
                        <span className="mmm__arrow mmm__arrow--right">
                          <i className="fa fa-chevron-right"></i>
                        </span>
                      </label>
                      <ul className="mmm__menu mmm__menu--sub">
                        <li className="mmm__item mmm__item--title mmm__item--back-nav">
                          <label
                            className="mmm__label mmm__label--back-nav"
                            htmlFor={`sub-${i}`}
                          >
                            <span className="mmm__arrow mmm__arrow--left">
                              <i className="fa fa-chevron-left"></i>
                            </span>
                            <span>
                              {this.props.t(
                                'navbar.sidebar_backtomainmenu',
                                'Back to main menu'
                              )}
                            </span>
                          </label>
                        </li>
                        {menu.menuItems.map((value) =>
                          value.map((items) => this.renderListItems(items))
                        )}
                      </ul>
                    </li>
                  )
                );
              }
              return (
                <li key={i} className="mmm__item">
                  <label className="mmm__label">
                    <Link
                      to={this.props.tRoute(menu.href)}
                      className="sidebar_menu_color"
                      onClick={this.props.toggleSidebar}
                    >
                      {menu.label}
                    </Link>
                  </label>
                </li>
              );
            })}
          </ul>
        </li>
      </ul>
    );
  }
}

SideBar.propTypes = {
  logo: PropTypes.string.isRequired,
  menus: PropTypes.array.isRequired,
  sideBarOpen: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/Nav/SideBar.js